import { Container, Divider, Heading } from "@chakra-ui/react";
import CardForm from "components/ui/CardForm";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import { useResource } from "hooks/useResource";
import { useParams } from "react-router-dom";
import ThemeForm from "../components/ThemeForm";

export default function PageEditTheme() {
  const { id } = useParams();
  const { data: theme } = useResource({
    id: id as string,
    resourceName: "contentParameter",
    path: "/content-parameters",
  });
  return (
    <>
      <HeaderBarInternal title="Editar tema" backTo="/temas" />
      <Divider />

      <Container variant="internal" flexDirection="column">
        <Heading as="h1" size="h1">
          Dados do tema
          <span>Identifique um novo tema Patri</span>
        </Heading>

        <CardForm>{theme && <ThemeForm theme={theme} />}</CardForm>
      </Container>
    </>
  );
}
